import React, {Fragment} from "react";
import {
    ArrowIcon,
    CustomBadge,
    CustomTableRow,
    CustomTD,
    StyledTable,
    StyledTableHeaderCell
} from "@pages/new-design-components/custom-components";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import {formatDateFullGB} from "@constants/index";

export default function InvoicesTable({keys,tableData = [],loading = false,filter,setOrderItem,viewDetails, disableButton = false}) {

    const generateItem = ({ item, index, key }) => {
        if (key === 'number_type') {
            return <CustomTD key={index} color={'#3F8CFF'} className="cursor-pointer">{item[key]}</CustomTD>;
        }
        else if (key === 'due_date' || key === 'issue_date' || key === 'paid_date') {
            const date = formatDateFullGB(item[key]);
            const isOverdue = key === 'due_date' && item[key] && new Date(item[key]) < new Date();
            return <CustomTD key={index} color={isOverdue ? '#e83838' : '#3F8CFF'} className="cursor-pointer">{date || '-'}</CustomTD>;
        }
       else if ( key === 'amount_due') {
            return <CustomTD key={index}>£{item[key]}</CustomTD>;
        }

       else if (key === 'total') {
            return <CustomTD key={index}>£{item.total}</CustomTD>;

        }
       else if (key === 'invoice_status') {
            const isPaid = item.invoice_status?.toLowerCase() === 'paid';
             const value = item.invoice_status === 'AUTHORISED' ? 'Awaiting payment' : item.invoice_status
             return (
                <CustomTD key={index}>
                    <CustomBadge type={isPaid ? 'success' : 'warning'}>
                        {value}
                    </CustomBadge>
                </CustomTD>
            );
        }

       else if (key === 'sent') {
            return <CustomTD key={index}>{item.sent ? 'Sent' : '-'}</CustomTD>;
        } else if (key === 'view') {
           return <CustomTD key={index} color={disableButton ? 'grey' : '#3F8CFF'} onClick={()=>{ !disableButton && viewDetails(item?.xero_invoice_id) }}
                      className={'text-center cursor-pointer'}
            >  View </CustomTD>
        }
       // else if (key === 'copy') {
       //    return  <CustomTD key={index} className="gap-2">
       //        <IcoMoon
       //             id={'copied_'+index}
       //            className={'cursor-pointer '}
       //            iconSet={IconSet}
       //            icon={'ic_copy'}
       //            size={20}
       //            onClick={()=>{
       //                setTooltipId('copied_' + index);
       //                copyToClipboard(JSON.stringify(item)).then(res=>{
       //                    setTimeout(()=>{
       //                        setTooltipId(null)
       //                    },2000)
       //                });
       //            }}
       //        />
       //            <UncontrolledTooltip
       //                placement="top"
       //                target={'copied_'+index}
       //                trigger="click"
       //                autohide={true}
       //                isOpen={'copied_'+index === tooltipId}
       //            >
       //                Copied!
       //            </UncontrolledTooltip>
       //      </CustomTD>
       //  }

        return <CustomTD key={index}>{item[key] || '-'}</CustomTD>;
    };

    return (
        loading ?
            <LoaderContainer>
                <ClipLoader
                    size={40}
                    color={`#7B61E4`}
                />
            </LoaderContainer>
            :
           <div className={'table-container'}>
               <StyledTable className={'table-borderless'}>
                   <thead className={'header-white-text'}>
                   <tr>
                       {keys.map((item,index)=>{
                           return    <Fragment key={`${index}_hd`}>
                               <StyledTableHeaderCell fontSize='14px' color={'#0000008C'}>
                                   {item?.sort &&    <ArrowIcon
                                       isOpen={(filter?.order_by === item.key) ? filter?.order === 'asc' : false}
                                       src={require("assets/images/arrow_forward_ios.png")}
                                       alt="Dropdown Arrow"
                                       onClick={()=>{
                                           setOrderItem({order_by: item.key, order: (filter?.order_by === item.key) ? (filter?.order === 'asc' ? 'desc' : 'asc') : 'asc'})
                                       }}
                                   />}
                                   {item.label}
                               </StyledTableHeaderCell>
                           </Fragment>
                       })}

                   </tr>
                   </thead>
                   <tbody>
                   {tableData.length ?
                       tableData.map((item,index)=>{
                           return <CustomTableRow key={`${index}_td`}>
                               {
                                   keys.map(({key}, keyIndex) => {
                                       return generateItem({item, index: `${index}_${keyIndex}`,key, itemIndex: index});
                                   })
                               }
                           </CustomTableRow>

                       }) : null
                   }
                   </tbody>
               </StyledTable>
           </div>
    )
}